import axios from 'axios'

const state = {
  isAdding: false
}

const actions = {
  ADD_RECEIVED_ORDER: async ({commit}, submitData) => {
    try {
      commit('SET_IS_ADDING_RECEIVED_ORDER', true)
      const url = 'received-orders'
      const res = await axios.post(url, submitData)
      commit('SET_IS_ADDING_RECEIVED_ORDER', false)
      console.log('check res', res)
    } catch (e) {
      commit('SET_IS_ADDING_RECEIVED_ORDER', false)
      console.log('check error', e)
    }
  }
}

const mutations = {
  SET_IS_ADDING_RECEIVED_ORDER: (state, status) => {
    state.isAdding = status
  }
}

const getters = {
  getState: state => {
    return state
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/received.order.js